import type { GridColumnsSelectorSlotProps } from './typings'

export function isSelectorSlotProps(
  obj: unknown,
): obj is GridColumnsSelectorSlotProps {
  const test = obj as GridColumnsSelectorSlotProps
  if (test && test.defaultVisibility) return true
  return false
}
